import { apiBaseURL } from '../ProjectConstants';

function buildWorkCenterFormData(row) {
  const fd = new FormData();
  fd.append('Name', row.name ?? '');

  const typeText =
    row.type === 0 ? 'Research' :
    row.type === 1 ? 'Operation' :
    String(row.type ?? '');
  fd.append('Type', typeText);

  fd.append('WorkTasks', JSON.stringify(row.tasks ?? []));
  if (row.numberOfFulltimes != null)
    fd.append('NumberOFFulltimes', String(row.numberOfFulltimes));
  if (row.numberOfStudents != null)
    fd.append('NumberOfStudents', String(row.numberOfStudents));

  const raw = row.__imageFile;
  const file = Array.isArray(raw) ? raw[0] : raw;
  if (file && file.name) {
    fd.append('Image', file, file.name);
  }

  return fd;
}

async function handlePostWorkCenter(fetch, row) {
  const fd = buildWorkCenterFormData(row);

  const response = await fetch.post(`${apiBaseURL}/api/WorkCenter`, fd);
  const isDataGood =
    response?.success &&
    response?.data?.statusCode &&
    response?.success !== 'Invalid Model';

  console.log('handlePostWorkCenter body', row);
  console.log('handlePostWorkCenter response', response);

  return {
    response,
    isDataGood,
  };
}

export default handlePostWorkCenter;
